module.exports = __webpack_public_path__ + "assets/img/apply.4557659a.png";